import React, { useState } from "react";
import api from "../../api";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { FiPlusCircle, FiArrowDownCircle, FiArrowUpCircle } from "react-icons/fi";

const TransactionForm = ({ investorId, onSaved }) => {
  const { t } = useTranslation();

  const [form, setForm] = useState({
    type: "deposit",
    amount: "",
    date: "",
    category: "",
  });

  const selectType = (type) => {
    setForm((prev) => ({ ...prev, type }));
  };

  const submit = async () => {
    if (!form.amount || !form.date) {
      toast.warn(t("transactions.requiredFields"));
      return;
    }
    try {
      await api.post("/transactions", {
        investor_id: investorId,
        ...form,
      });
      toast.success(t("transactions.created"));
      onSaved();
      setForm({ type: "deposit", amount: "", date: "", category: "" });
    } catch {
      toast.error(t("transactions.creationFailed"));
    }
  };

  return (
    <div className="bg-base-100 rounded-xl border border-base-200 shadow-sm p-5 space-y-4">
      {/* Section title */}
      <div className="flex items-center gap-2">
        <FiPlusCircle className="text-primary text-base" />
        <h2 className="text-sm font-semibold text-base-content">
          {t("transactions.add")}
        </h2>
      </div>

      {/* Type toggle */}
      <div className="flex gap-2">
        <button
          className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-colors border ${
            form.type === "deposit"
              ? "bg-success/10 border-success text-success"
              : "bg-base-200 border-base-300 text-base-content/50 hover:bg-base-300"
          }`}
          onClick={() => selectType("deposit")}
        >
          <span className="flex items-center justify-center gap-1.5">
            <FiArrowDownCircle /> {t("transactions.deposit")}
          </span>
        </button>
        <button
          className={`flex-1 py-2 rounded-lg text-sm font-semibold transition-colors border ${
            form.type === "withdrawal"
              ? "bg-error/10 border-error text-error"
              : "bg-base-200 border-base-300 text-base-content/50 hover:bg-base-300"
          }`}
          onClick={() => selectType("withdrawal")}
        >
          <span className="flex items-center justify-center gap-1.5">
            <FiArrowUpCircle /> {t("transactions.withdrawal")}
          </span>
        </button>
      </div>

      {/* Fields */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        <input
          type="number"
          placeholder={t("transactions.amount")}
          className="input input-bordered bg-base-200 border-base-300 text-base-content focus:border-primary focus:outline-none"
          value={form.amount}
          onChange={(e) =>
            setForm({ ...form, amount: parseFloat(e.target.value) })
          }
        />
        <input
          type="date"
          aria-label="date"
          className="input input-bordered bg-base-200 border-base-300 text-base-content focus:border-primary focus:outline-none"
          value={form.date}
          onChange={(e) => setForm({ ...form, date: e.target.value })}
        />
        <input
          type="text"
          placeholder={t("transactions.categoryOptional")}
          className="input input-bordered bg-base-200 border-base-300 text-base-content focus:border-primary focus:outline-none"
          value={form.category}
          onChange={(e) => setForm({ ...form, category: e.target.value })}
        />
      </div>

      {/* Submit */}
      <div className="flex justify-end">
        <button
          onClick={submit}
          className={`btn gap-2 ${
            form.type === "deposit" ? "btn-success" : "btn-error"
          }`}
        >
          <FiPlusCircle className="text-base" />
          {t("transactions.add")} {t(`transactions.${form.type}`)}
        </button>
      </div>
    </div>
  );
};

export default TransactionForm;
